export default {
  女装: "Жіночий одяг",
  男装: "Чоловічий",
  手机和小工具: "Мобільний телефон та невеликі інструменти",
  居家生活: "Домашнє життя",
  电脑及周边设备: "Комп'ютерне та периферійне обладнання",
  美容及个人护理: "Краса та особиста допомога",
  家用电器: "Прилад",
  健康与保健: "Охорона здоров'я та охорона здоров'я",
  食品和饮料: "Їжа та напої",
  玩具_儿童和婴儿: "Іграшки, діти та немовлята",
  童装时尚: "Мода дитячого одягу",
  视频游戏: "відеоігри",
  运动与户外: "Вправи та на свіжому повітрі",
  爱好与书籍: "Хобі та книги",
  相机和无人机: "Камера та безпілотники",
  宠物食品及用品: "Їжа та приладдя для домашніх тварин",
  女士包袋: "Дамська сумка",
  男士包袋: "Чоловіча сумка",
  珠宝及配饰: "Ювелірні вироби та аксесуари",
  手表: "стежити",
  女鞋: "Жіноче взуття",
  男装鞋: "Чоловіче взуття",
  汽车: "машина",
  我附近的ShopeePay: "Мій сусідній shopeepay",
  餐饮_旅行和服务: "Харчування, подорожі та обслуговування",
  旅行及行李: "Подорожі та багаж",
  各种各样的: "Різний",
  我是来买什么的: "Я тут, щоб купити",
  对不起_找不到_相关的商品:
    "Вибачте, ви не можете знайти [{0}] пов’язані продукти",
  类别: "категорія",
  产品: "продукт",
  店铺: "Магазин",
  首页: "головна сторінка",
  限时秒杀: "Обмежений час часу",
  博客: "блог",
  所有品牌: "Усі бренди",
  所有类别: "Усі категорії",
  我的购物车: "Мій кошик для покупок",
  发货信息: "Інформація про доставку",
  交货信息: "Інформація про доставку",
  付款: "Оплата",
  确认: "підтверджувати",
  您的购物车是空的: "Ваш кошик порожній",
  价格: "ціна",
  税: "Податковий",
  数量: "кількість",
  总计: "загальний",
  移除: "Видалити",
  返回商店: "Повернення до магазину",
  继续发货: "Продовжити доставку",
  筛选: "фільтрувати",
  价格范围: "Ціна",
  排序方式: "сортувати",
  最新: "актуальний",
  最旧: "Старий",
  价格从低到高: "Ціна від низької до високої",
  价格从高到低: "Ціна від високої до низької",
  选择交货类型: "Виберіть тип доставки",
  送货上门: "Доставка",
  继续付款: "Продовжуйте платити",
  任何其他信息: "Будь -яка інша інформація",
  或者: "або",
  您的钱包余额: "Ваш баланс гаманця",
  余额不足: "Недостатній баланс",
  支付: "Оплачувати",
  我同意: "Я згоден",
  条款和条件: "Умови",
  退货政策: "Політика повернення",
  隐私政策: "Приватність",
  概括: "Підсумовувати",
  项目: "демонструвати",
  全部的: "Весь",
  小计: "Замальовка",
  总运费: "Загальний вантаж",
  有优惠码吗_在这里输入: "Чи є код знижки? Увійдіть сюди",
  申请: "Застосовувати",
  编辑: "редагувати",
  删除: "видаляти",
  添加新地址: "Додайте нову адресу",
  继续交货信息: "Продовжити інформацію про доставку",
  选择一个地址: "Виберіть адресу",
  购买历史: "Купуйте історію",
  下载: "завантажувати",
  已发送退款请求: "Запит на повернення коштів надсилає запит на відшкодування",
  对比: "контрастувати",
  对话: "діалог",
  我的钱包: "Мій гаманець",
  工单: "Робочий порядок",
  管理个人资料: "Керуйте особистою інформацією",
  登出: "Виходити",
  重置对比列表: "Скидання списку порівняння",
  您的对比列表为空: "Ваш список порівняння порожній",
  在您的购物车中: "У вашому кошику",
  在您的愿望清单中: "У вашому списку побажань",
  在您的预定列表中: "У вашому запланованому списку",
  下载您的产品: "Завантажте свій продукт",
  选项: "Опція",
  什么都没找到: "Я нічого не знайшов",
  特色产品: "Спеціальний продукт",
  最畅销: "Найкращі продажу",
  前_名: "Попереднє {0} Ім'я",
  查看更多: "Переглянути більше",
  查看所有类别: "Переглянути всі категорії",
  十大品牌: "Десять найкращих брендів",
  查看所有品牌: "Переглянути всі бренди",
  登录: "Увійти",
  手机号码: "Номер телефону",
  密码: "пароль",
  密码长度为6到16个字符: "Довжина пароля становить від 6 до 16 символів",
  验证码: "Код перевірки",
  登录中: "Увійти",
  游客登录: "Туристичний логін",
  注册您的商店: "Зареєструйте свій магазин",
  现在申请: "Подайте заявку зараз",
  成为商家: "Стати торговцем",
  现在注册: "Зареєструйтесь зараз",
  登录成功: "Успішний вхід",
  通知: "повідомляти",
  未找到通知: "Ніякого сповіщення",
  评论: "Коментувати",
  估计运输时间: "Орієнтовний час транспорту",
  天: "небо",
  所售: "Розпродаж",
  给商家留言: "Залиште повідомлення торговцям",
  规格: "Специфікація",
  库存: "на складі",
  总价: "Загальна ціна",
  添加到购物车: "Додати до візка",
  立即购买: "Купуйте зараз",
  缺货: "поза запасом",
  添加到愿望清单: "Додати до списку побажань",
  加入对比列表: "Додайте список порівняння",
  退款: "Повернути",
  查看条款: "Переглянути пункт",
  分享: "розподіляти",
  描述: "описувати",
  相关产品: "Супутні продукти",
  没有人问过商家: "Ніхто не просив у продавця",
  该产品暂无评论: "Немає коментарів до цього продукту",
  客户评论: "Коментар клієнта",
  访问商店: "Відвідайте магазин",
  畅销产品: "Найкращі продажу продуктів",
  日期: "дата",
  订单编号: "Номер замовлення",
  总额: "одноразова сума",
  状态: "держави",
  愿望清单: "Список побажань",
  还没有添加任何东西: "Ще нічого не додав",
  注册: "реєстрація",
  邀请码: "Код запрошення",
  请输入邀请码: "Введіть код запрошення",
  用户名: "Ім'я користувача",
  请输入用户名: "Введіть ім'я користувача",
  用户名长度为6_14个字符: "Довжина імені користувача-6-14 символів",
  昵称: "Прізвище",
  请输入手机号码: "Введіть номер мобільного телефону",
  手机号码格式错误: "Помилка формату мобільного телефону",
  密码长度为6_16个字符: "Довжина пароля-6-16 символів",
  确认密码: "Підтвердити пароль",
  请输入确认密码: "Введіть пароль підтвердження",
  提款密码: "Пароль виведення",
  请输入提款密码: "Введіть пароль виведення",
  提款密码长度为4_16个字符: "Довжина пароля виведення-4-16 символів",
  请输入验证码: "Введіть код підтвердження",
  在_s后发送: "Надіслати після {0} s",
  发送验证码: "Надішліть код підтвердження",
  注册即表示您同意我们的条款和条件:
    "Реєстрація означає, що ви погоджуєтесь з нашими умовами.",
  创建账号: "Створити обліковий запис",
  验证码发送成功: "Код підтвердження успішно надсилається",
  确认密码不一致: "Підтвердити, що пароль непослідовний",
  提款密码必须为数字: "Пароль виведення повинен бути пронумерований",
  注册成功: "Зареєструйтесь успішно",
  购物车: "Кошик для покупок",
  账户: "Рахунок",
  我的账户: "Мій рахунок",
  已经有一个账户: "Вже є рахунок",
  新地址: "Нова адреса",
  编辑地址: "Адреса редактора",
  保存: "заощадити",
  是否默认: "Чи за замовчуванням",
  具体地址: "Конкретна адреса",
  请输入具体地址: "Введіть конкретну адресу",
  地区: "область",
  请输入地区: "Будь ласка, введіть область",
  城市: "Місто",
  请输入城市: "Будь ласка, введіть місто",
  省份: "провінція",
  请输入省份: "Будь ласка, введіть провінцію",
  邮政编码: "поштовий індекс",
  请输入邮政编码: "Введіть поштовий індекс",
  电话号码: "Номер телефону",
  请输入电话号码: "Введіть номер телефону",
  收货人: "вихователь",
  请输入收货人: "Будь ласка, введіть вантажник",
  保存成功: "Бути успішним",
  最畅销的商家: "Найкращий продавець торговця",
  查看所有的商家: "Перевірте всіх торговців",
  支持政策: "Політика підтримки",
  您的电子邮件地址: "Ваша електронна адреса",
  订阅: "підписка",
  联系方式: "Контактна інформація",
  地址: "адреса",
  美国伊利诺伊州霍夫曼庄园: "Holfman Manor, Іллінойс, США",
  快速链接: "Швидке посилання",
  商家政策: "Торговельна політика",
  submit: "подавати",
  提款银行卡: "ADBB -карта",
  我的面板: "Моя панель",
  提示: "підказка",
  确定登出吗: "Ви впевнені, що входить?",
  确定: "Упевнений",
  取消: "Скасувати",
  项目添加到您的购物车: "Проект додається до вашого кошика",
  经常一起购买: "Купуйте часто",
  返回购物: "Повернути покупки",
  进行结算: "перейти до оформлення замовлення",
  帮助热线: "Допоможіть гарячій лінії",
  查看所有通知: "Перевірте всі сповіщення",
  请输入密码: "Введіть пароль",
  前往充值: "Перейдіть до поповнення",
  购物车物品: "Кошик для покупок",
  查看购物车: "Перевірте кошик для покупок",
  钱包余额: "Баланс гаманця",
  充值钱包: "Підзарядка",
  钱包充值_线下_: "Підзарядка гаманця (в режимі офлайн)",
  申请提款: "Подайте заявку на відкликання",
  钱包收支明细: "Деталі доходу від гаманців та витрат",
  批准: "затверджувати",
  提现历史记录: "Набір історичного запису",
  类型: "тип",
  信息: "інформація",
  付款方式: "Метод оплати",
  请选择付款方式: "Виберіть метод оплати",
  Bill_Type_RECHARGE_BACK: "Фонове зарядка",
  Bill_Type_RECHARGE_ONLINE: "Інтернет -поповнення",
  Bill_Type_RECHARGE_REGISTER: "Реєстрація",
  Bill_Type_RECHARGE_JACKPOT: "Підзарядка",
  Bill_Type_RECHARGE_PRESENT: "Поповнення винагороди",
  Bill_Type_RECHARGE_FROM_COMMISSION: "Передача комісії",
  Bill_Type_RECHARGE_TG_COMMISSION: "Комісія з підвищення кваліфікації",
  Bill_Type_REGISTER_TG_COMMISSION: "Комісія з реєстрації та просування",
  Bill_Type_WITHDRAW: "Відступати",
  Bill_Type_WITHDRAW_REJECT: "Відступати",
  Bill_Type_DEDUCT_HANDLE: "Ручне відрахування",
  Bill_Type_DEDUCT_RECHARGE_MONEY: "Підзарядка",
  Bill_Type_MINING_PROFIT: "Дохід від видобутку",
  Bill_Type_MINING_PROFIT_COMMISSION:
    "Комісія з підвищення доходу від видобутку",
  Bill_Type_VIP_UPGRADE: "Оновіть VIP",
  Bill_Type_FINANCE_BUY: "Купівля товару з управління багатством",
  Bill_Type_FINANCE_CAPITAL_RETURN: "Повернення фінансового балансу",
  Bill_Type_FINANCE_FEE: "Плата за фінансову обробку",
  Bill_Type_FINANCE_PROFIT: "Фінансовий дохід",
  Bill_Type_FINANCE_BUY_COMMISSION:
    "Купівля комісій для продуктів з управління багатством",
  Bill_Type_FINANCE_PROFIT_COMMISSION:
    "Комісія з доходу від продукту управління багатством",
  Bill_Type_WHEEL_DRAW: "Великий розіграш повороту",
  Bill_Type_BUY: "Купуйте товари",
  Bill_Type_PAY_SHOP: "Плата за доставку",
  Bill_Type_BUY_COMMISSION: "Купуйте комісію з товарів",
  Bill_Type_DEPOSIT: "Сплатити депозит",
  Bill_Type_STORE_BUY: "Купуйте товари",
  Bill_Type_STORE_BUY_REFUND: "Купуйте повернення коштів",
  Bill_Type: "Тип зміни боргу",
  Before_Money: "Попередня сума",
  Deal_Money: "Сума зміни рахунку",
  After_Money: "Подальша сума",
  Bill_Time: "Час зміни рахунку",
  No_More_Data: "Більше немає даних",
  Apply_Money: "Сума заявки",
  Apply_Time: "Час застосування",
  Withdraw_Info: "Плата за обробку: {плата}, на рахунок: {гроші}",
  提款订单状态_CHECKING: "Переглянути",
  提款订单状态_TRANSFERRING: "Перенесення",
  提款订单状态_PASS: "Підтверджувати",
  提款订单状态_REJECT: "Відхилений",
  暂无可用充值方式: "Немає корисного методу перезарядки",
  钱包收款码: "Код збору гаманців",
  钱包地址: "Адреса гаманця",
  金额限制: "Обмеження суми",
  复制: "копіювати",
  付款凭证: "Ваучер на платіж",
  收款银行: "Банк, що підлягає дебіторській залозі",
  收款人: "Касир",
  收款账号: "Рахунок квитанції",
  付款银行: "Оплата банку",
  付款人: "Платник",
  付款账号: "Платіжний рахунок",
  请输入付款银行: "Введіть платіжний банк",
  请输入付款人: "Введіть платника",
  请输入付款账号: "Будь ласка, введіть платіжний рахунок",
  请上传付款凭证: "Будь ласка, завантажте ваучери для платежів",
  充值金额: "Сума зарядки",
  请输入充值金额: "Будь ласка, введіть суму підзарядки",
  submitting: "Подано ...",
  Confirm: "подавати",
  Commit_Success: "Успішне подання",
  balanceType_BALANCE: "Балансувати",
  balanceType_COMMISSION: "комісія",
  Balance: "Баланс на рахунку",
  Wash_Money: "Кодування",
  请选择银行账户: "Виберіть банківський рахунок",
  卡号类型: "Номер картки",
  提现金额: "Сума зняття коштів",
  提款金额: "Сума зняття коштів",
  不能为空: "Не може бути порожнім",
  金额不正确: "Неправильна сума",
  please_input_withdraw_password: "Введіть пароль виведення",
  withdraw_password_format_error:
    "Пароль виведення повинен бути 4-16-бітними символами",
  Fee: "Плата за керування",
  实际到账: "Власне",
  交易币种: "Торгова валюта",
  原始密码: "Примітивний пароль",
  confirm_password_error: "Пароль у двох входах невірний",
  save_success: "Бути успішним",
  please_input: "Будь ласка, введіть",
  old_password: "Старий пароль",
  new_password: "Новий пароль",
  please_input_confirm_password: "Будь ласка, підтвердьте пароль ще раз",
  没有找到符合条件的商品: "Не вдається знайти кваліфіковану продукцію",
  Search: "обшук",
  全部: "все",
  EnumGoodsOrderState_USER_PAY: "Розподіляти",
  EnumGoodsOrderState_SHOP_PAY: "Розподіл",
  EnumGoodsOrderState_SUCCESS: "Закінчити",
  EnumGoodsOrderState_CANCEL: "Скасувати",
  EnumGoodsOrderState_REFUND_SUCCESS: "Повернути",
  订单号: "Номер замовлення",
  用户名称: "Ім'я користувача",
  收益: "дохід",
  支付时间: "Сплачувати час",
  配送时间: "Час доставки",
  完成时间: "Повний час",
  发货: "Корабель",
  全选: "Повний вибір",
  物品已添加到愿望清单: "Елементи додані до списку бажань",
  物品已添加到比较列表: "Елементи додані до списку порівняння",
  购买成功提示: "Вітаємо, успішно купуйте",
  订单列表: "Список замовлень",
  商品名: "Назва товару",
  图片: "малюнок",
  没有品牌: "Немає бренду",
  基本信息: "Основна інформація",
  Account_Name: "Назва",
  Bank_Account: "Банківський рахунок",
  Bank_Phone: "Резервуйте номер мобільного телефону",
  IFSC: "Рахунок IFSC",
  UPI: "Рахунок UPI",
  PIX: "Номер рахунку PIX",
  CPF: "Рахунок CPF",
  GCASH: "Обліковий запис GCASH",
  POWWI: "Рахунок powwi",
  身份证号: "Ідентифікаційний номер",
  Edit: "Переглянути",
  Delete: "видаляти",
  Add: "Збільшувати",
  Forget_Withdraw_Password: "Забудьте з паролем виведення",
  Bank_Card_Info: "Інформація про банківські картки",
  收款人地址: "Адреса каси",
  SWIFT: "Швидкий",
  Bank_Branch: "Назва суббранка",
  分行代码: "Код гілки",
  银行地址: "Банківська адреса",
  Email: "Електронна пошта",
  银行卡长度必须超过:
    "Довжина банківської картки повинна перевищувати {довжина}",
  银行卡格式不正确: "Формат банківської картки неправильний",
  Do_you_confirm_delete: "Ви підтверджуєте видалення?",
  Please_Login_First: "Будь ласка, увійдіть спочатку",
  Bank_Name: "Назва банку",
  Please_add_bank_first:
    "Ви не привернули банківську карту, будь ласка, додайте її спочатку",
  withdrawType: "Вилучення",
  withdraw_money_limit:
    "Кількість зняття повинна бути перевищувати 0 і менше або дорівнює {балансу}",
  withdraw_times_limit:
    "Ви сьогодні витягнули {сьогоднішніми} разів. Чи вирішено зняти гроші?",
  Copy_Success: "Реплікація",
  商店首页: "Зберігайте домашню сторінку",
  所有产品: "Всі продукти",
  新到货产品: "Новий продукт, що належить",
  所有商家: "Всі торговці",
  请上传: "Будь ласка, завантажте",
  请输入: "Будь ласка, введіть",
  忘记密码: "Забудьте пароль",
  记得我: "Пам'ятайте мене",
  共_件: "Всього {0} шматок",
  取消订单: "Скасувати замовлення",
  申请退款: "Подайте заявку на повернення коштів",
  未知商家: "Невідомий торговець",
  到账: "Рахунок",
  提款订单状态: "Статус замовлення на відкликання",
  前_名类别: "Категорія першої {0}",
  取消订单原因_不想要了: "Не хочу більше",
  取消订单原因_商品错选_多选: "Помилки продукту/багаторазовий вибір",
  取消订单原因_商品无货: "З -out -foods",
  取消订单原因_地址信息填写错误: "Заповніть помилку інформації про адресу",
  取消订单原因_商品降价: "Зниження ціни на товар",
  取消订单原因_价格高于其他平台: "Ціна вища, ніж інші платформи",
  取消订单原因_没用_少用_错用优惠:
    "Нічого/не використовуйте менше/знижку на помилку",
  退款原因_拍错_多拍_不喜欢:
    "Візьміть неправильно/стріляйте більше/не подобається",
  退款原因_商品成分描述不符: "Опис компонента продукту не відповідає",
  退款原因_与商家协商一致退款: "Консультація з відшкодуванням торговців",
  退款原因_生产日期_保质期与商品描述不符:
    "Дата виробництва/термін зберігання не відповідає опису продукту",
  退款原因_图片_产地_批号_规格等描述不符:
    "Зображення/місце походження/номер партії/специфікації тощо.",
  退款原因_质量问题: "Якісна проблема",
  退款原因_商品变质_发霉_有异物: "Product Plop/Cold/Ionstration Body",
  退款原因_少件_含缺少配件_:
    "Маленькі предмети (включаючи відсутність аксесуарів)",
  退款原因_收到商品时有破损_污渍_变形:
    "Під час отримання продукту є пошкодження/пляма/деформація",
  退款原因_假冒品牌: "Підроблений",
  退款原因_发票问题: "Проблема рахунків -фактур",
  退款原因_商家发错货: "Купці надсилають неправильні товари",
  退款原因_预约不到_商家不给退换:
    "Не можу домовитись про зустріч/торговець не повернеться",
  退款失败: "Відшкодування відшкодування",
  退款处理中: "Обробка повернення коштів",
  默认: "за замовчуванням",
  产品查询: "Запит на товар",
  商店LOGO: "Логотип магазину",
  推广码: "Промоція коду",
  查看所有: "Перевірте все",
  确认收货成功: "Підтвердити, що квитанція є успішною",
  物流公司: "Логістична компанія",
  物流单号: "Номер логістичного замовлення",
  发货时间: "Час доставки",
  请先选择商品规格: "Спочатку виберіть специфікацію продукту",
  个人信息: "Особиста інформація",
  您的用户名: "Ваше ім'я користувача",
  你的名字: "Ваше ім'я",
  登录名: "Ім'я користувача",
  你的邮件: "Ваша пошта",
  你的密码: "Ваш пароль",
  重复输入密码: "Повторіть пароль",
  店铺名称: "Назва магазину",
  证书类型: "Тип",
  身份证: "Посвідчення особи",
  护照: "паспорт",
  驾驶执照: "посвідчення водія",
  社会保障卡: "Картка соціального забезпечення",
  证书正面: "Позитивний сертифікат",
  证书反面: "Обстеження",
  确认收货: "підтвердити отримання товарів",
  请选择取消订单的原因必选:
    "Виберіть причину скасування замовлення (необхідне):",
  请选择申请退款的原因必选:
    "Будь ласка, виберіть причину подання заявки на повернення коштів (необхідне):",
  留言: "повідомлення",
  请输入留言: "Введіть повідомлення",
  没有帐户: "Немає рахунку",
  钱包充值: "Підзарядка гаманця",
  输入您的文字: "Введіть свій текст",
  商家登录: "Торговець логіном",
  有关此产品的任何查询: "Будь -який запит на цей продукт",
  产品名称: "Назва товару",
  你的问题: "Ваша проблема",
  白银店铺: "Срібний магазин",
  铂金店铺: "Платиновий магазин",
  钻石店铺: "Алмазний магазин",
  照片: "фото",
  已退货: "Повернутий",
  邮寄状态: "Статус пошти",
  订单摘要: "Замовлення",
  收件地址: "Адреса прибутку",
  订购日期: "Дата замовлення",
  订单状态: "Статус замовлення",
  总订单金额: "Загальна сума замовлення",
  邮寄方式: "Метод розсилки",
  附加信息: "Додаткова інформація",
  订单详细信息: "Детальна інформація",
  交货类型: "Тип доставки",
  进行评论: "Коментувати",
  已评论: "Коментований",
  订单金额: "Сума замовлення",
  优惠券: "Купон",
  统一运费: "Об'єднаний вантаж",
  送货地址: "Адреса доставки",
  评分: "оцінка",
  你的意见: "Ваша думка",
  匿名: "анонімний",
  现金: "готівка",
  详情: "Деталь",
  收货地址: "Адреса квитанції",
  暂时没有对话: "На даний момент немає діалогу",
  你: "ти",
  输入您的回复: "Введіть свою відповідь",
  删除成功: "Видаляти",
  品牌: "бренд",
  已缴纳的保证金: "Заплатив маржу",
  黄金店铺: "Золотий магазин",
  没有更多数据: "Більше немає даних",
  站内信: "На -сайті",
  系统通知: "Повідомлення про систему",
  邮箱: "Пошта",
  手机号: "Номер телефону",
  你的手机号: "Номер вашого мобільного телефону",
  营业执照: "Ділова ліцензія",
  你的邮箱: "Ваша поштова скринька",
  搜索结果: "Результати пошуку",
  系统公告: "Оголошення системи",
  客服: "Обслуговування клієнтів",
  消息已撤回: "Новина була знята",
  物流详情: "Деталі логістики",
  充值: "накопичувати",
  提现: "Відступати",
  信用分: "Кредит",
  余额: "Балансувати",
  佣金: "комісія",
  继续购物: "Продовжуйте покупки",
  订单结算: "Замовити врегулювання",
  加入对比: "Додайте порівняння",
  佣金余额: "Комісія балансу",
  刷新: "оновлювати",
  刷新成功: "Оновлювати",
  官网: "Офіційний веб -сайт",
  税号: "Номер податків",
  订单: "Наказ",
  合计: "загальний",
  系统安全: "Системна безпека",
  Recharge_Money_Limit: "Сума зарядки повинна бути між {min} та {max}",
  限时优惠: "Обмежений час",
  高价回收: "Високо цінна переробка",
  姓名: "Назва",
  商品订单号: "Номер товарного замовлення",
  商品在线回收: "Това онлайн -переробка",
  提交: "подавати",
  回收记录: "Запис відновлення",
  回收状态: "Статус відновлення",
  回收价格: "Ціна переробки",
  纳税码: "Податковий кодекс",
  买家登录: "Увійти",
  买家注册: "реєстрація",
  language: "Китайський",
  助力提示:
    "Допомога торговців може збільшити вплив платформи на свої магазини, і чим вище кумулятивна кількість днів, тим вище експозиція.",
  已累计助力: "Кумулятивно допомагає",
  今日已助力: "Сьогодні допоміг",
  立即助力: "Допомогти негайно",
  商家助力: "Торговельна допомога",
  证件号码: "Ідентифікаційний номер",
  证书号码: "Номер сертифіката"
};
